export type TTabs = 'Weekly' | 'Monthly' | 'Yearly';
export const TABS: { [key: string]: TTabs } = {
	WEEKLY: 'Weekly',
	MONTHLY: 'Monthly',
	YEARLY: 'Yearly',
};
